// extracted by mini-css-extract-plugin
export default {"container":"DeliveryPolicy_container__tVSXz","chatLink":"DeliveryPolicy_chatLink__veFuC"};